import React from 'react';
import { format, isToday, differenceInCalendarDays } from 'date-fns';
import { useRecentActivities } from '../../hooks/useDashboardQueries';
import { LedgerSkeleton } from '../shell/LedgerSkeleton';

function stamp(iso: string): string {
  const d = new Date(iso);
  if (isToday(d)) return `TODAY ${format(d, 'HH:mm')}`;
  if (differenceInCalendarDays(new Date(), d) < 7) return format(d, 'EEE HH:mm').toUpperCase();
  return format(d, 'MMM d, yyyy').toUpperCase();
}

export const Journal: React.FC = () => {
  const { data, isPending } = useRecentActivities(6);

  return (
    <section aria-label="Journal" className="mt-6">
      <div className="flex justify-between border-b border-ink pb-1">
        <span className="cap-label !text-ink">Journal</span>
        <span className="cap-label">Last 7 days</span>
      </div>
      {isPending ? (
        <LedgerSkeleton lines={3} className="mt-3" />
      ) : !data || data.length === 0 ? (
        <p className="py-4 font-serif text-scale-1 italic text-ink-muted">No entries this week.</p>
      ) : (
        data.map((a) => (
          <div key={a.id} className="flex gap-3 py-1.5 text-scale-1">
            <span className="w-20 shrink-0 font-mono text-scale-0 text-ink-muted">{stamp(a.timestamp)}</span>
            <span className="min-w-0 text-ink">
              {a.user_name} {a.title.toLowerCase()}{' '}
              <span className="text-accent">{a.description}</span>
            </span>
          </div>
        ))
      )}
    </section>
  );
};
